import { useState, DragEvent, ChangeEvent } from "react";

interface UploadSpreadSheetProps {
  processDataOfUploadedFile: (file: File | null) => void;
}

function UploadSpreadSheet({
  processDataOfUploadedFile,
}: UploadSpreadSheetProps) {
  const [isDragOver, setIsDragOver] = useState<boolean>(false);

  const readFile = (event: ChangeEvent<HTMLInputElement>) => {
    if (processDataOfUploadedFile) {
      event.preventDefault();
      const file = event.target.files?.[0] || null;
      processDataOfUploadedFile(file);
    }
  };

  const handleOnDragOver = (event: DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    setIsDragOver(true);
  };

  const handleOnDragLeave = (event: DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    setIsDragOver(false);
  };

  const handleOnDrop = (event: DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    setIsDragOver(false);

    const file = event.dataTransfer.files[0];
    if (processDataOfUploadedFile) {
      processDataOfUploadedFile(file);
    }
  };

  return (
    <div className="h-full px-6 pb-6">
      <div
        className={`flex h-full flex-col items-center justify-center rounded-lg border-2 border-dashed border-gray-200 ${
          isDragOver ? "border-blue-500" : ""
        }`}
        onDragOver={handleOnDragOver}
        onDragLeave={handleOnDragLeave}
        onDrop={handleOnDrop}
      >
        <p className="text-center normal-case">
          Upload .xlsx, .xls or .csv file
        </p>
        <div className="mt-4">
          <label
            className="ms-auto cursor-pointer rounded bg-blue-600 px-4 py-2 text-white"
            htmlFor="uploadFile"
          >
            Select file
            <input
              type="file"
              accept=".csv, .tsv, .xlsx, .xml"
              className="hidden"
              id="uploadFile"
              onChange={readFile}
            />
          </label>
        </div>
      </div>
    </div>
  );
}

export default UploadSpreadSheet;
